import Vue from 'vue';
import Snackbar from './Snackbar.vue';

Vue.component('snackbar', Snackbar);
